'use client';

import { c as _c } from "react/compiler-runtime";
import { Eye, EyeOff, Server } from 'lucide-react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
};
export const AnonymousPostExplanationModal = t0 => {
  const $ = _c(12);
  const {
    closeHandler
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2"><EyeOff className="text-primary" /><h2 className="text-xl font-semibold">Anonymous Posts</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== closeHandler) {
    t2 = <ModalHeader closeHandler={closeHandler}>{t1}</ModalHeader>;
    $[1] = closeHandler;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-lg">Anonymous posts hide your identity from other users, but the server still knows who you are.</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-start gap-3"><Eye className="mt-1 text-primary" /><div><h3 className="font-semibold">Public Anonymity</h3><p className="text-sm text-textSecondary">Other users cannot see your name, avatar, or profile on anonymous posts. Your identity is hidden from the public.</p></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ModalContent><div className="space-y-6 py-2">{t3}<div className="space-y-4">{t4}<div className="flex items-start gap-3"><Server className="mt-1 text-amber-500" /><div><h3 className="font-semibold">Server Awareness</h3><p className="text-sm text-textSecondary">The server knows who posted it for moderation and safety purposes. In a future update we will find a way to better make this private.</p></div></div></div></div></ModalContent>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== closeHandler) {
    t6 = <ModalFooter><Button text="Got it" variant="PRIMARY" onClick={closeHandler} /></ModalFooter>;
    $[6] = closeHandler;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== closeHandler || $[9] !== t2 || $[10] !== t6) {
    t7 = <Modal closeHandler={closeHandler}>{t2}{t5}{t6}</Modal>;
    $[8] = closeHandler;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};